var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.292 7.854a.5.5 0 1 0-.707-.707l.707.707ZM8.94 12.5l-.354.354a.5.5 0 0 0 .707 0L8.94 12.5Zm-1.92-2.626a.5.5 0 1 0-.707.707l.708-.707ZM17.834 10a7.833 7.833 0 0 1-7.834 7.834v1A8.833 8.833 0 0 0 18.833 10h-1Zm-7.834 7.834A7.833 7.833 0 0 1 2.166 10h-1a8.833 8.833 0 0 0 8.833 8.834v-1ZM2.166 10a7.833 7.833 0 0 1 7.833-7.833v-1A8.833 8.833 0 0 0 1.166 10h1Zm7.833-7.833A7.833 7.833 0 0 1 17.833 10h1a8.833 8.833 0 0 0-8.834-8.833v1Zm3.586 4.98-5 5 .707.707 5-5-.707-.707Zm-4.293 5L7.02 9.874l-.708.707 2.273 2.273.707-.707Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.22a57033.svg";
export { ForwardRef as ReactComponent };